export class SmoothScrollNavigation {
  private sections: NodeListOf<HTMLElement>;
  private navLinks: NodeListOf<HTMLAnchorElement>;
  private observer!: IntersectionObserver;

  constructor() {
    this.sections = document.querySelectorAll('.section');
    this.navLinks = document.querySelectorAll('nav a[data-section]');
    
    this.init();
  }

   init(): void {
    this.setupScrollObserver();
    this.setupNavigation();
    this.setupInitialVisibility();
  }

  private setupScrollObserver(): void {
    const options = {
        root: null,
        rootMargin: '-80px 0px -50% 0px', // Navbar height + only trigger when well into view
        threshold: 0
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const section = entry.target as HTMLElement;
        
        if (entry.isIntersecting) {
          // Add visible class for animation
          section.classList.add('visible');
          
          // Update active nav item
          this.updateActiveNavItem(section.id);
        }
      });
    }, options);

    // Observe all sections
    this.sections.forEach(section => {
      this.observer.observe(section);
    });
  }

  private setupNavigation(): void {
    this.navLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        
        const sectionId = link.getAttribute('data-section');
        if (sectionId) {
          this.scrollToSection(sectionId);
        }
      });
    });
       // Mobile menu toggle
    const mobileMenu = document.querySelector('.mobile-menu');
    mobileMenu?.addEventListener('click', this.toggleMobileMenu);
  }

  private scrollToSection(sectionId: string): void {
    const section = document.getElementById(sectionId);
    if (section) {
      const offsetTop = section.offsetTop - 80; // Account for fixed nav height
      
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  }

  private updateActiveNavItem(activeSectionId: string): void {
    this.navLinks.forEach(link => {
      const sectionId = link.getAttribute('data-section');
      
      if (sectionId === activeSectionId) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });
  }

  private setupInitialVisibility(): void {
    // Check which sections are initially visible
    const firstSection = this.sections[0];
    if (firstSection) {
      firstSection.classList.add('visible');
      this.updateActiveNavItem(firstSection.id);
    }
  }



    // Mobile menu toggle
  private toggleMobileMenu(): void {
    const navLinks = document.getElementById('navLinks');
    navLinks?.classList.toggle('active');
  }

  // Method to programmatically scroll to a section
  public navigateToSection(sectionId: string): void {
    this.scrollToSection(sectionId);
  }

  // Cleanup method
  public destroy(): void {
    this.observer.disconnect();
    this.navLinks.forEach(link => {
      link.removeEventListener('click', () => {});
    });
  }
}

